export default __webpack_public_path__ + "static/media/map-search-icon.5fd01221.svg";